var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 7,
  viewBox: "185 19 10 7"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m194.82 20.819-.713-.68a.516.516 0 0 0-.714-.002L190 23.416l-3.423-3.303a.52.52 0 0 0-.716 0l-.713.68a.464.464 0 0 0 0 .678l4.494 4.33c.2.186.52.186.715 0l4.466-4.302a.46.46 0 0 0 0-.68z"
})));
export { SvgArrowDown as ReactComponent };
export default __webpack_public_path__ + "assets/media/arrowDown.14fb9f27f522403791af2918b94098b5.svg";